module.exports = __webpack_public_path__ + "img/req_cus.4011fff0.png";